// extracted by mini-css-extract-plugin
module.exports = {"app__footer":"r_5","app__footer__copyFoot":"r_6"};